import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { DataSection } from "@/components/DataSection";

import { PermissionDoorsDialog } from "./PermissionDoorsDialog";

import type { Member } from "@/models";

interface MemberPermissionGroupProps {
  data: Member;
}

export function MemberPermissionGroup({ data }: MemberPermissionGroupProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const dialog = searchParams.get("dialog");
  const id = searchParams.get("id");

  function onCloseDialog() {
    searchParams.delete("dialog");
    setSearchParams(searchParams);
  }

  function onClickBranch(branchId: number) {
    searchParams.set("dialog", "branch-door");
    searchParams.set("id", branchId.toString());
    setSearchParams(searchParams);
  }

  const { doorPermission, memberships } = data;

  const branches = doorPermission?.branches ?? [];

  const membershipBranches =
    memberships?.reduce((memo, { product: { productBranches } }) => {
      productBranches.forEach(({ branch }) => {
        const isSameBranch = memo.some(({ id }) => id === branch.id);
        if (!isSameBranch) {
          memo.push(branch);
        }
      });
      return memo;
    }, [] as { id: number; name: string }[]) ?? [];

  const isHasBranch = membershipBranches.length > 0;

  const selectedBranch = membershipBranches.find(
    (branch) => branch.id.toString() === id
  );
  const selectedBranchWithDoors = branches.find(
    (branch) => branch.id.toString() === id
  );
  const selectedDoors = selectedBranchWithDoors?.doors ?? [];

  const columns = [
    [
      {
        title: "",
        data: [
          { label: "ชื่อสิทธิ์การใช้งานประตู", value: doorPermission?.name },
          {
            label: "สาขา",
            key: doorPermission?.id?.toString() ?? "-",
            value: (
              <Stack gap={2}>
                {isHasBranch
                  ? membershipBranches.map(({ id, name }) => (
                      <Typography
                        key={id}
                        variant="body2"
                        onClick={() => onClickBranch(id)}
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                      >
                        {name}
                      </Typography>
                    ))
                  : "-"}
              </Stack>
            ),
          },
        ],
      },
    ],
  ];

  const permissionDoorsDialog = {
    open: dialog === "branch-door",
    onClose: onCloseDialog,
    doors: selectedDoors,
    branch: selectedBranch,
  };

  return (
    <Card>
      <CardHeader title="สิทธิ์การใช้งานประตู" />
      <CardContent>
        <DataSection columns={columns} />
      </CardContent>
      <PermissionDoorsDialog {...permissionDoorsDialog} />
    </Card>
  );
}
